import { pulseTracker, PulseEvent } from './../tracking/pulse-tracker'
import Vue from 'vue'
import { TRACKING_PROVIDER_ID } from '@/constants'

declare module 'vue/types/vue' {
  interface Vue {
    $track: (params: PulseEvent, eventType?: string) => {} ;
  }
}

const Tracker = {
  install (Vue): void {
    pulseTracker.startTrackerWithId(TRACKING_PROVIDER_ID)

    Vue.prototype.$track = Vue.track = (params: PulseEvent, eventType = 'trackerEvent'): void => {
      try {
        pulseTracker.trackEvent(params, eventType)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
}

export { Tracker }
